import React, { useEffect, useState } from "react";
import styles from "./pay-with-opay.module.scss";
import {
  closeLoader,
  openLoader,
} from "../../redux/actions/loader/loaderActions";
import { useDispatch, useSelector } from "react-redux";
import {
  TrackOrderStatusAction,
  closeWin,
  payOrderAction,
} from "../../redux/actions/orderStatus/orderStatusAction";
import { useTimerContext } from "../../hooks/use-timer-context";
import { ClipLoader } from "react-spinners";
import transactpay from "../../assets/images/iconlogo.png";
import CopyToClipboard from "react-copy-to-clipboard";
import { ContentCopy } from "@mui/icons-material";
import { commarize } from "../../utils/helpers";

type Props = {
  reference?: string;
};
const PayWithOpay: React.FC<Props> = ({ reference }) => {
  const [providerUrl, setProviderUrl] = useState<string | null>(null);
  const dispatch = useDispatch();
  const { startTimer } = useTimerContext();

  // get details - email & amount
  const { orderDetails } = useSelector((state) => state.orderDetailsReducer);

  const merchantEmail =
    orderDetails?.data?.subsidiary?.email ??
    orderDetails?.data?.customer?.email;

  useEffect(() => {
    handleSubmit();
  }, [reference]);

  const updatePendingStatus = (__window: Window | null) => {
    closeWin(__window);
  };
  const handleSubmit = () => {
    dispatch(openLoader("Loading...", ""));
    try {
      const payload = {
        reference: reference,
        paymentoption: "Opay",
        country: "NG",
      };
      payOrderAction(payload, "opay", dispatch, (data: any) => {
        setProviderUrl(data.data.paymentDetail.redirectUrl);
      });
    } catch (error) {
    } finally {
      dispatch(closeLoader());
    }
  };

  const handleRedirectClicked = () => {
    startTimer(900);
    const payload = {
      reference: reference,
      paymentoption: "Opay",
      country: "NG",
    };
    setTimeout(() => {
      TrackOrderStatusAction(payload, "opay", dispatch, updatePendingStatus);
    }, 1000);
  };

  return (
    <div className={styles.container}>
      {providerUrl ? (
        <>
          <div
            style={{
              fontSize: "smaller",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
              justifyContent: "end",
              padding: "10px 0px",
            }}
          >
          </div>

          <div className={styles.choose}>
            <p className={styles.instruction}>
              You will be redirected to bank page to complete the payment
            </p>
            <a
              href={providerUrl}
              target="_blank"
              rel="noreferrer"
              onClick={handleRedirectClicked}
              className={styles.confirmRedirectButton}
            >
              Click to Proceed
            </a>

            <div className={styles.poweredByBox}>
              <p className={styles.poweredBy}>Powered by</p>
              <img
                src={transactpay}
                style={{ width: "auto", height: "20px", objectFit: "cover" }}
                alt="Transactpay"
              />
            </div>
          </div>
        </>
      ) : (
        <div className={styles.loaderContainer}>
          <ClipLoader color="#8e173e" size={40} />
        </div>
      )}
    </div>
  );
};

export default PayWithOpay;
